import { ProductBadges } from '../../components/badges/ProductBadges';
import { SelectStatus } from '../commons/commonFunctions';

export const contactBuyerForm = [
  {
    col: [12],
    name: 'name',
    label: 'Nombre',
    copyable: true,
  },
  {
    col: [8],
    name: 'email',
    label: 'Correo',
    copyable: true,
  },
  {
    col: [4],
    name: 'identificationNum',
    label: 'N.I.F. / C.I.F.',
    copyable: true,
  },
];

export const contactSellerForm = [
  {
    col: [12],
    name: 'name',
    label: 'Nombre',
    copyable: true,
  },
  {
    col: [8],
    name: 'email',
    label: 'Correo',
    copyable: true,
  },
  {
    col: [4],
    name: 'identificationNum',
    label: 'N.I.F. / C.I.F.',
    copyable: true,
  },
];

export const saleForm = {
  structure: {
    buyer: {},
    seller: {},
    saleProducts: [],
    documents: [],
  },
  errors: {},
  blocks: [
    {
      col: [4],
      card: [
        {
          col: [6],
          name: 'Información Cliente',
          type: 'title',
        },
        // {
        //     col: [4],
        //     name: 'paid',
        //     type: 'toggle',
        //     label: 'Estado de Pago',
        // },
        {
          type: 'card',
          collection: ['buyer'],
          subTitle: 'Datos del cliente',
          card: [...contactBuyerForm],
        },
      ],
    },
    {
      col: [4],
      card: [
        {
          col: [6],
          name: 'Información Vendedor',
          type: 'title',
        },
        {
          type: 'card',
          collection: ['seller'],
          card: [...contactSellerForm],
        },
      ],
    },
    {
      col: [4],
      card: [
        {
          type: 'card',
          col: [4],
          collection: ['vehicle'],
          card: [
            {
              col: [12],
              name: 'Información vehículo',
              type: 'title',
            },
            {
              col: [8],
              name: 'plate',
              label: 'Matrícula',
              copyable: true,
            },
            {
              col: [4],
              name: 'enrollmentDate',
              label: 'Fecha de matriculación',
              type: 'date',
              readOnly: true,
              copyable: true,
            },
            {
              col: [4],
              name: 'vehicleType',
              label: 'Tipo de vehiculo',
              type: 'select',
              isDisabled: true,
              customOptions: [
                { label: 'Coche', value: 'Car' },
                { label: 'Moto', value: 'Moto' },
              ],
              copyable: true,
            },
            {
              col: [4],
              name: 'fuel',
              type: 'select',
              label: 'Tipo de motor',
              isDisabled: true,
              customOptions: [
                { label: 'DIESEL', value: 'D' },
                { label: 'ELÉCTRICO', value: 'Elc' },
                { label: 'GASOLINA', value: 'G' },
                { label: 'GASOLINA GLP-CNG', value: 'S' },
                { label: 'ETANOL Y GASOLINA', value: 'M' },
                { label: 'HÍBRIDO DIESEL-ELÉCTRICO', value: 'DyE' },
                { label: 'HÍBRIDO GASOLINA-ELÉCTRICO', value: 'GyE' },
              ],
              copyable: true,
            },
            {
              col: [4],
              name: 'ccaaId',
              label: 'Comunidad Autónoma',
              type: 'select',
              isDisabled: true,
              endPoint: 'ccaa',
              copyable: true,
            },
            {
              col: [4],
              name: 'kw',
              condition: ['vehicleType||eq||Moto', 'fuel||eq||Elc'],
              label: 'Potencia (kw)',
              type: 'number',
              copyable: true,
            },
            {
              col: [4],
              name: 'cc',
              condition: ['vehicleType||eq||Moto', 'fuel||ne||Elc'],
              label: 'Cilindrada (cc)',
              type: 'number',
              readOnly: true,
              copyable: true,
            },
            {
              col: [6],
              name: 'brandStr',
              label: 'Marca',
              readOnly: true,
              copyable: true,
            },
            {
              col: [6],
              name: 'modelStr',
              label: 'Modelo',
              readOnly: true,
              copyable: true,
            },
          ],
        },
      ],
    },
    {
      col: [5],
      interpreter: 'ListInterpreter',
      title: 'Tramites',
      base: {
        // endPoint: 'saleProduct',
        isClearable: false,
        isMini: true,
        listCollection: ['form', 'saleTramit'],
        className: 'table-documents',
        listOptions: {
          columns: [
            {
              name: 'Tramite',
              selector: 'name',
              sortable: false,
              searchable: false,
              width: '60%',
            },
            {
              name: 'Estado',
              selector: 'name',
              sortable: false,
              searchable: false,
              width: '25%',
              cell: (row, index) => {
                const options = [
                  {
                    value: 'En Revisión',
                    label: (
                      <ProductBadges
                        text={'En Revisión'}
                        status={'En Revisión'}
                        fullColorizedStatus={true}
                      />
                    ),
                  },
                  {
                    value: 'Autorizando',
                    label: (
                      <ProductBadges
                        text={'Autorizando'}
                        status={'Autorizando'}
                        fullColorizedStatus={true}
                      />
                    ),
                  },
                  {
                    value: 'Procesando',
                    label: (
                      <ProductBadges
                        text={'Procesando'}
                        status={'Procesando'}
                        fullColorizedStatus={true}
                      />
                    ),
                  },
                  {
                    value: 'Hecho',
                    label: (
                      <ProductBadges
                        text={'Hecho'}
                        status={'Hecho'}
                        fullColorizedStatus={true}
                      />
                    ),
                  },
                ];
                return SelectStatus(row, index, options, 'saleProduct', false, [
                  'saleProducts',
                  index,
                ]);
              },
            },
          ],
        },
      },
    },
    {
      col: [7],
      interpreter: 'DocumentationInterpreter',
      title: 'Documentación',
      endPoint: 'sale',
      collection: ['documents'],
    },
    {
      col: [5],
      interpreter: 'ListInterpreter',
      title: 'Detalles del Pedido',
      base: {
        // endPoint: 'saleProduct',
        isClearable: false,
        isMini: true,
        listCollection: ['form', 'saleProducts'],
        className: 'table-documents',
        listOptions: {
          columns: [
            {
              name: 'Tramite',
              selector: 'name',
              sortable: false,
              searchable: false,
              width: '60%',
            },
            {
              name: 'Precio',
              selector: 'price',
              sortable: false,
              searchable: false,
              width: '15%',
            },
          ],
        },
      },
    },
  ],
};
